import { useState } from "react";
import { useNavigate } from "hooks/useCustomNavigation";
import { getSearchResults, getSearchSuggestions } from "./search";
import { nameToSlug } from "utils/strings";
import { getBrandSellData } from "utils/getBrandSellData";

export const useSellSearch = () => {
  const navigate = useNavigate();
  const [searchResults, setSearchResults] = useState([]);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [error, setError] = useState(null);

  const searchByName = (query) => {
    const searchResults = getSearchResults(query);
    setSearchSuggestions([]);

    if (!searchResults.length) {
      const searchSuggestions = getSearchSuggestions(query);
      setSearchSuggestions(searchSuggestions);
    }

    setSearchResults(searchResults);
  };

  const submitValue = (searchValue) => {
    setSearchResults([]);
    const brandSlug = nameToSlug(searchValue);
    const url = `/sell-${brandSlug}-gift-cards`;

    const isValidSellPage = getBrandSellData(brandSlug);

    if (isValidSellPage) {
      window.history.pushState(window.location.href, "");
      return navigate(url, { replace: true });
    }

    const searchSuggestions = getSearchSuggestions(searchValue);
    setError(true);
    setSearchSuggestions(searchSuggestions);
  };

  return {
    error,
    searchResults,
    searchSuggestions,
    setError,
    searchByName,
    setSearchResults,
    setSearchSuggestions,
    submitValue
  };
};
